// @ts-nocheck

import { TUnknownParam } from '@utils/diff/helpers';

export {};

if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, 'flat', {
    configurable: true,
    value: function flat(...args: TUnknownParam[]) {
      const depth: number = isNaN(args[0]) ? 1 : Number(args[0]);

      return depth
        ? Array.prototype.reduce.call(
            this,
            function (acc: TUnknownParam[], cur: TUnknownParam): TUnknownParam[] {
              if (Array.isArray(cur)) {
                acc.push(...flat.call(cur, depth - 1));
              } else {
                acc.push(cur);
              }

              return acc;
            },
            [],
          )
        : Array.prototype.slice.call(this);
    },
    writable: true,
  });
}

if (!Array.prototype.flatMap) {
  Object.defineProperty(Array.prototype, 'flatMap', {
    configurable: true,
    value: function flatMap(...args: TUnknownParam[]): TUnknownParam[] {
      return this.map(...args).flat();
    },
    writable: true,
  });
}
